<template>
  <v-container fluid class="success-page pa-4 pa-sm-6">
    <v-row justify="center" align="center" class="fill-height">
      <v-col cols="12" sm="10" md="8" lg="6">
        <v-card class="success-card pa-6 pa-sm-8 text-center" rounded="xl" elevation="12">
          <v-avatar size="72" color="#e8f1ef" class="mb-4">
            <v-icon size="40" color="#2f6f65">mdi-check</v-icon>
          </v-avatar>

          <h1 class="success-title">Registration successful</h1>
          <p class="success-text">
            Your form has been submitted successfully. Thank you for completing the registration.
          </p>

          <div class="success-actions">
            <v-btn color="#2f6f65" rounded="lg" size="large" elevation="0" @click="$router.push('/registration')">
              Back to registration
            </v-btn>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>
.success-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  background: linear-gradient(135deg, #5c837a 0%, #719991 48%, #dce7e2 100%);
}

.success-card {
  background: #ffffff;
}

.success-title {
  margin: 0 0 12px;
  color: #172725;
  font-size: 2rem;
  font-weight: 700;
}

.success-text {
  margin: 0;
  color: #5f6f6c;
  line-height: 1.7;
}

.success-actions {
  margin-top: 24px;
}

@media only screen and (max-width: 700px) {
  .success-title {
    font-size: 1.6rem;
  }
}
</style>
